module.exports = __webpack_public_path__ + "img/honor-right-1-3.eebc8b2b.jpg";